import { PitchLocationChartConfigDto, BatterSingleSessionReportChartConfigDto, PitchLocationGrouping } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

const BatterSingleSessionPitchLocationChartSidebar = ({
  chartConfig,
  setTempLayout,
  tempLayout,
}: ChartConfigProps<PitchLocationChartConfigDto, BatterSingleSessionReportChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle('BatterSingleSessionPitchLocationChart', chartConfig)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['GroupOrType', 'PitchCall'] satisfies PitchLocationGrouping[]}
        selected={chartConfig.pitchLocationGrouping}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            batterSingleSessionPitchLocationChartConfig: {
              ...tempLayout.batterSingleSessionPitchLocationChartConfig,
              pitchLocationGrouping: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default BatterSingleSessionPitchLocationChartSidebar;
